import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject, take, takeUntil } from 'rxjs';
import { GeneralService } from 'src/app/services/general.service';
import { PosSettingsService } from 'src/app/services/pos-settings.service';
import { PosOpeningCashDrawerService } from 'src/app/services/pos_OpeningCashDrawer.service';
import { UserService } from 'src/app/services/User.service';
import { EActionTypes, EDenominations, EDenominationsListOfValues, ELovTypes, EToaster, EUserSecurityFunctionID } from 'src/app/Shared/enum';
import { IOpenCashCoinsAndBillsModel, IOpenCashModel, IPOSTerminal, POSSettingsModel } from 'src/app/Shared/Interfaces/IPOSSettings';
import { ITwoDigitDecimalInput, IUserPermissionHandler } from 'src/app/Shared/model/CommonModel';
import { ANGULAR_MODULES, OperationsComponent, SYNCFUSION_MODULES, TopBarComponent } from 'src/app/Shared/shared-imports';
import { SharedHTMLSettingsDataService } from 'src/app/Shared/sharedHTMLSettingsData.service';
import { CommonCalculatorService } from 'src/app/Shared/commonCalculators.service';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { TwoDigitDecimalDirective } from 'src/app/Shared/restrictToTwoDigitDecimal.directive';
import { UserPermissionHandlerDirective } from 'src/app/Shared/userPermissionHandler.directive';
import Swal from 'sweetalert2';
import { LoaderComponent } from 'src/app/Shared/loader/loader.component';
import { Router } from '@angular/router';
import { ReportsService } from 'src/app/services/report.service';
import { IReportResponse } from 'src/app/Shared/model/ReportsModel';
import { OperationRentalService } from 'src/app/services/Rentals.service';

@Component({
  selector: 'app-ops-opening-cash-drawer-amount',
  imports: [SYNCFUSION_MODULES, ANGULAR_MODULES, LoaderComponent, OperationsComponent, TopBarComponent, TwoDigitDecimalDirective, UserPermissionHandlerDirective],
  standalone: true,
  templateUrl: './ops-opening-cash-drawer-amount.html',
  styleUrl: './ops-opening-cash-drawer-amount.scss'
})
export class OpsOpeningCashDrawerAmount implements OnInit, OnDestroy {

  isCollapsed = true;
  previousDayEndNotProcessed = false;
  @Output() openCashSaved = new EventEmitter<any>();
  public datePipe = new DatePipe('en-US');
  @ViewChild('gridCoinsBills') public gridCoinsBills?: GridComponent;
  public loaderIcon: Promise<boolean>;
  private destroy$ = new Subject<void>();
  selectedTerminal: string = null;
  posOpenCashDetails: IOpenCashModel;
  currentDate: Date = new Date();
  openingCashDrawerAmount = '$0';
  openingDateTime = new Date();
  userName = '';
  reportUrl;
  marketId: any;
  listCoinsAndBills = [];
  posTerminals: IPOSTerminal[] = [];
  checkCoinsBills = false;
  defaultOpenCashAmount = 0;
  gridTotal = 0;
  viewPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.OpeningCashDrawer, Action: EActionTypes.VIEW };
  createPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.OpeningCashDrawer, Action: EActionTypes.CREATE };
  editPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.OpeningCashDrawer, Action: EActionTypes.EDIT };
  decimalRestrictInput: ITwoDigitDecimalInput = {
    Length: 7,
    IsCurrency: true,
    DefaultMinimum: false,
    MinimumValue: '0.00',
    MaximumValue: '9999999.99',
    WholeValue: false,
  };
  @Input() hideOpenCashTopMenu: boolean = false;
  allowEditOpeningCash = false;
  UsersList = [];
  selectedUser;
  superUser = false;
  defaultUser;
  filteredUsersList = [];
  isUserwiseDayend: boolean = true;

  constructor(
    private posSettingsService: PosSettingsService,
    private posOpeningCashDrawerService: PosOpeningCashDrawerService,
    private userService: UserService,
    private sharedHTMLSettings: SharedHTMLSettingsDataService,
    private generalService: GeneralService,
    private UserService: UserService,
    private commonCalculatorService: CommonCalculatorService,
    private router: Router,
    private toastr: ToastrService,
    private service: ReportsService,
    private operationRentalService: OperationRentalService,
  ) {
  }

  ngOnInit(): void {
    this.userName = this.userService.getLoggedInUserName();
    this.selectedUser = this.userService.getLoggedInUserId();
    this.defaultUser = this.selectedUser;
    this.allowEditOpeningCash = this.generalService.UserPermissions.UserRoles.AllowEditOpeningCash;
    this.superUser = this.generalService.UserPermissions.UserRoles.SuperUser;
    this.getPOSTerminals();
    this.getPOSSettings();
    this.getDenominations();
    this.loadUsersList();
    this.getMarketCurrentTime();
    this.getReportUrl();
    this.operationRentalService.getDefaultMarketId().subscribe((res: any) => {
      if (res) {
        this.marketId = res;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  calculateTotalCost(data, args): void {
    const count = args.target.value ?? 0;
    let denomination = 0;
    switch (data.Name) {
      case EDenominationsListOfValues.Pennies: denomination = EDenominations.Pennies;
        break;

      case EDenominationsListOfValues.Nickels: denomination = EDenominations.Nickels;
        break;

      case EDenominationsListOfValues.Dimes: denomination = EDenominations.Dimes;
        break;

      case EDenominationsListOfValues.Quarter: denomination = EDenominations.Quarter;
        break;

      case EDenominationsListOfValues['Half Dollars']: denomination = EDenominations['Half Dollars'];
        break;

      case EDenominationsListOfValues['Dollar Coins']: denomination = EDenominations['Dollar Coins'];
        break;

      case EDenominationsListOfValues['$1 Bills']: denomination = EDenominations['$1 Bills'];
        break;

      case EDenominationsListOfValues['$2 Bills']: denomination = EDenominations['$2 Bills'];
        break;

      case EDenominationsListOfValues['$5 Bills']: denomination = EDenominations['$5 Bills'];
        break;

      case EDenominationsListOfValues['$10 Bills']: denomination = EDenominations['$10 Bills'];
        break;

      case EDenominationsListOfValues['$20 Bills']: denomination = EDenominations['$20 Bills'];
        break;

      case EDenominationsListOfValues['$50 Bills']: denomination = EDenominations['$50 Bills'];
        break;

      case EDenominationsListOfValues['$100 Bills']: denomination = EDenominations['$100 Bills'];
        break;
    };
    this.gridCoinsBills.setCellValue(data.Name, 'Amount', this.commonCalculatorService.roundToDecimalPlace(denomination * count, 2));
    let totalAmount = this.listCoinsAndBills.reduce((sum, item) => this.commonCalculatorService.roundToDecimalPlace(sum + item.Amount, 2), 0);
    if (totalAmount > this.decimalRestrictInput.MaximumValue) {
      args.target.value = 0;
      this.gridCoinsBills.setCellValue(data.Name, 'Amount', 0);
      totalAmount = this.listCoinsAndBills.reduce((sum, item) => this.commonCalculatorService.roundToDecimalPlace(sum + item.Amount, 2), 0);
    }
    this.gridTotal = totalAmount > 0 ? (totalAmount) : 0;
    this.openingCashDrawerAmount = '$' + this.gridTotal.toString();
    let selectedObject = this.listCoinsAndBills.find(l => l.Name == data.Name);
    selectedObject.Count = count;
  }

  handleToggle(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  loadUsersList() {
    this.loaderIcon = Promise.resolve(true);
    this.UserService.getUserList().pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.UsersList = res;
        },
        error: (err) => {
        }
      });
  }

  changeUser(value) {
    if (value && value != 'null') {
      this.gridTotal = 0;
      this.previousDayEndNotProcessed = false;
      this.openingCashDrawerAmount = this.defaultOpenCashAmount > 0 ? ('$' + this.defaultOpenCashAmount) : '$0';
      this.posOpenCashDetails = null;
      this.getMarketCurrentTime();
      this.changeOpeningCashDrawer();
      this.getOpeningCash(this.selectedTerminal);
      const userObject = this.UsersList.find(r => r.UserId == value);
      if (userObject) {
        this.userName = userObject.UserName
      }
    }
  }

  getDenominations() {
    this.generalService.getListOfValuesByType(ELovTypes.Denominations).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.listCoinsAndBills = res.map(denomination => {
          denomination['Count'] = 0;
          denomination['Amount'] = 0;
          return denomination;
        });
      },
      error: err => console.error('Failed to load font options', err)
    });
  }

  getMarketCurrentTime(): void {
    this.generalService.GetMarketCurrentTime()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          const newCurrentDateTime = new Date(parseInt(res.substring(0, 4), 10), parseInt(res.substring(5, 7), 10) - 1, parseInt(res.substring(8, 10), 10),
            parseInt(res.substring(11, 13), 10), parseInt(res.substring(14, 16), 10), parseInt(res.substring(17, 19), 10), 0);
          this.openingDateTime = newCurrentDateTime;
          this.currentDate = newCurrentDateTime;
        },
        error: (err) => {
        }
      });
  }

  changePOsTerminal(value) {
    this.gridTotal = 0;
    this.previousDayEndNotProcessed = false;
    this.openingCashDrawerAmount = this.defaultOpenCashAmount > 0 ? ('$' + this.defaultOpenCashAmount) : '$0';
    this.posOpenCashDetails = null;
    this.getMarketCurrentTime();
    this.changeOpeningCashDrawer();
    this.selectedUser = this.defaultUser;
    if (value && value != 'null') {
      const usersWithTodayOpenCash = this.posTerminals.find(p => p.Name == this.selectedTerminal).UsersWithCurrentDateOpenCash;
      this.filteredUsersList = this.UsersList.filter(u => {
        return usersWithTodayOpenCash.includes(u.UserId) || u.UserId == this.defaultUser;
      })
      this.getOpeningCash(value);
    }
  }

  getPOSTerminals() {
    this.loaderIcon = Promise.resolve(true);
    this.posOpeningCashDrawerService.getPOSTerminals().pipe(takeUntil(this.destroy$)).subscribe({
      next: (response: IPOSTerminal[]) => {
        this.loaderIcon = Promise.resolve(false);
        if (response) {
          this.posTerminals = response;
          this.getDefaultTerminalId();
        }
      },
      error: (error) => {
        this.loaderIcon = Promise.resolve(false);
        this.toastr.error(EToaster.MsgErrorFetch + $localize`:@@POSTerminal:POS Terminal`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
      },
    });
  }

  getDefaultTerminalId() {
    this.userService.getDefaultTerminalId().pipe(take(1)).subscribe(res => {
      if (res && res != 0) {
        const terminalObj = this.posTerminals.find(x => x.Id == res);
        if (terminalObj) {
          this.selectedTerminal = terminalObj.Name;
          this.changePOsTerminal(terminalObj.Name);
        }
        this.generalService.setTerminal(res);
      }
    });
  }

  getOpeningCash(terminalName: string) {
    const selectedDateString = this.datePipe.transform(this.openingDateTime, 'MM/dd/yyyy');
    this.loaderIcon = Promise.resolve(true);

    // Always pass the selected user. The backend ignores the user ID in Terminal-wise mode
    // and applies user filtering only when User-wise Day End is enabled.
    const userId = this.selectedUser;

    this.posOpeningCashDrawerService.getOpeningCash(terminalName, selectedDateString, this.selectedUser).pipe(takeUntil(this.destroy$)).subscribe({
      next: (response: IOpenCashModel) => {
        this.loaderIcon = Promise.resolve(false);
        this.posOpenCashDetails = response;
        if (this.posOpenCashDetails && this.posOpenCashDetails.PreviousEODNotProcessedDate) {
          this.previousDayEndNotProcessed = true;
          const dateEODNotProcessed = this.posOpenCashDetails.PreviousEODNotProcessedDate.substring(5, 7) + '/' + this.posOpenCashDetails.PreviousEODNotProcessedDate.substring(8, 10) + '/' + this.posOpenCashDetails.PreviousEODNotProcessedDate.substring(0, 4);
          this.posOpenCashDetails.PreviousEODNotProcessedDate.substring(0, 10)
          Swal.fire({
            text: $localize`:@@MsgDayendForDateNotSubmitted:The Day end for date: ${dateEODNotProcessed} is not submitted!`,
            icon: "warning",
            confirmButtonText: $localize`:@@Ok:Ok`
          });
        }
        if (response && response.Id != 0) {
          this.openingCashDrawerAmount = this.posOpenCashDetails.OpeningCashAmount > 0 ? ('$' + this.posOpenCashDetails.OpeningCashAmount) : '0';
          if (this.posOpenCashDetails.OpeningCashCoinsAndBills) {
            this.checkCoinsBills = true;
            this.gridTotal = this.posOpenCashDetails.OpeningCashAmount > 0 ? (this.posOpenCashDetails.OpeningCashAmount) : 0;
            this.listCoinsAndBills.forEach(li => {
              switch (li.Name) {
                case EDenominationsListOfValues.Pennies: li.Count = this.posOpenCashDetails.OpeningCashCoinsAndBills.Count1 ?? 0;
                  li.Amount = this.posOpenCashDetails.OpeningCashCoinsAndBills.Val1 ?? 0;
                  break;

                case EDenominationsListOfValues.Nickels: li.Count = this.posOpenCashDetails.OpeningCashCoinsAndBills.Count2 ?? 0;
                  li.Amount = this.posOpenCashDetails.OpeningCashCoinsAndBills.Val2 ?? 0;
                  break;

                case EDenominationsListOfValues.Dimes: li.Count = this.posOpenCashDetails.OpeningCashCoinsAndBills.Count3 ?? 0;
                  li.Amount = this.posOpenCashDetails.OpeningCashCoinsAndBills.Val3 ?? 0;
                  break;

                case EDenominationsListOfValues.Quarter: li.Count = this.posOpenCashDetails.OpeningCashCoinsAndBills.Count4 ?? 0;
                  li.Amount = this.posOpenCashDetails.OpeningCashCoinsAndBills.Val4 ?? 0;
                  break;

                case EDenominationsListOfValues['Half Dollars']: li.Count = this.posOpenCashDetails.OpeningCashCoinsAndBills.Count5 ?? 0;
                  li.Amount = this.posOpenCashDetails.OpeningCashCoinsAndBills.Val5 ?? 0;
                  break;

                case EDenominationsListOfValues['Dollar Coins']: li.Count = this.posOpenCashDetails.OpeningCashCoinsAndBills.Count6 ?? 0;
                  li.Amount = this.posOpenCashDetails.OpeningCashCoinsAndBills.Val6 ?? 0;
                  break;

                case EDenominationsListOfValues['$1 Bills']: li.Count = this.posOpenCashDetails.OpeningCashCoinsAndBills.Count7 ?? 0;
                  li.Amount = this.posOpenCashDetails.OpeningCashCoinsAndBills.Val7 ?? 0;
                  break;

                case EDenominationsListOfValues['$2 Bills']: li.Count = this.posOpenCashDetails.OpeningCashCoinsAndBills.Count8 ?? 0;
                  li.Amount = this.posOpenCashDetails.OpeningCashCoinsAndBills.Val8 ?? 0;
                  break;

                case EDenominationsListOfValues['$5 Bills']: li.Count = this.posOpenCashDetails.OpeningCashCoinsAndBills.Count9 ?? 0;
                  li.Amount = this.posOpenCashDetails.OpeningCashCoinsAndBills.Val9 ?? 0;
                  break;

                case EDenominationsListOfValues['$10 Bills']: li.Count = this.posOpenCashDetails.OpeningCashCoinsAndBills.Count10 ?? 0;
                  li.Amount = this.posOpenCashDetails.OpeningCashCoinsAndBills.Val10 ?? 0;
                  break;

                case EDenominationsListOfValues['$20 Bills']: li.Count = this.posOpenCashDetails.OpeningCashCoinsAndBills.Count11 ?? 0;
                  li.Amount = this.posOpenCashDetails.OpeningCashCoinsAndBills.Val11 ?? 0;
                  break;

                case EDenominationsListOfValues['$50 Bills']: li.Count = this.posOpenCashDetails.OpeningCashCoinsAndBills.Count12 ?? 0;
                  li.Amount = this.posOpenCashDetails.OpeningCashCoinsAndBills.Val12 ?? 0;
                  break;

                case EDenominationsListOfValues['$100 Bills']: li.Count = this.posOpenCashDetails.OpeningCashCoinsAndBills.Count13 ?? 0;
                  li.Amount = this.posOpenCashDetails.OpeningCashCoinsAndBills.Val13 ?? 0;
                  break;
              };
            });
            this.gridCoinsBills.refreshColumns();
          }
        }
      },
      error: (error) => {
        this.loaderIcon = Promise.resolve(false);
        this.toastr.error(EToaster.MsgErrorFetch + $localize`:@@OpenCashDrawerAmt:Opening Cash Amount`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
      },
    });
  }

  getPOSSettings() {
    if (this.posSettingsService.pOSSetting) {
      this.defaultOpenCashAmount = this.posSettingsService.pOSSetting.OtherSettings?.OpeningCashAmount ?? 0;
      this.openingCashDrawerAmount = this.defaultOpenCashAmount > 0 ? ('$' + this.defaultOpenCashAmount) : '0';
    } else {
      this.posSettingsService.getPosSettings().pipe(takeUntil(this.destroy$)).subscribe({
        next: (data: POSSettingsModel) => {
          this.defaultOpenCashAmount = data.OtherSettings?.OpeningCashAmount ?? 0;
          this.openingCashDrawerAmount = this.defaultOpenCashAmount > 0 ? ('$' + this.defaultOpenCashAmount) : '0';
        },
        error: err => { }
      });
    }
  }

  saveOpeningCashDrawer() {
    if (this.posOpenCashDetails && this.posOpenCashDetails.EODDateTime) {
      Swal.fire({
        // title: $localize`:@@Confirm:`,
        text: $localize`:@@ConfirmOpenCashNotAllowed:The Opening cash amount for today has already been added! You can not add it again!`,
        icon: "warning",
        confirmButtonText: $localize`:@@Ok:Ok`
      });
    } else {
      Swal.fire({
        title: $localize`:@@Confirm:Confirm`,
        text: $localize`:@@ConfirmSaveOpenCash:Are you sure you want to save Opening Cash Amount?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: $localize`:@@Yes:Yes`,
        cancelButtonText: $localize`:@@No:No`
      }).then((result) => {
        if (result.isConfirmed) {
          this.saveModelAndAPICall();
        }
      });
    }
  }

  saveModelAndAPICall() {
    this.loaderIcon = Promise.resolve(true);
    const coinsAndBillsDetails: IOpenCashCoinsAndBillsModel =
    {
      CoinsBillId: (this.posOpenCashDetails && this.posOpenCashDetails.OpeningCashCoinsAndBills) ? this.posOpenCashDetails.OpeningCashCoinsAndBills.CoinsBillId : 0,
      Coin1: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues.Pennies).Name,
      Count1: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues.Pennies).Count,
      Val1: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues.Pennies).Amount,
      Coin2: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues.Nickels).Name,
      Count2: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues.Nickels).Count,
      Val2: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues.Nickels).Amount,
      Coin3: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues.Dimes).Name,
      Count3: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues.Dimes).Count,
      Val3: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues.Dimes).Amount,
      Coin4: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues.Quarter).Name,
      Count4: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues.Quarter).Count,
      Val4: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues.Quarter).Amount,
      Coin5: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['Half Dollars']).Name,
      Count5: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['Half Dollars']).Count,
      Val5: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['Half Dollars']).Amount,
      Coin6: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['Dollar Coins']).Name,
      Count6: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['Dollar Coins']).Count,
      Val6: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['Dollar Coins']).Amount,
      Coin7: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['$1 Bills']).Name,
      Count7: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['$1 Bills']).Count,
      Val7: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['$1 Bills']).Amount,
      Coin8: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['$2 Bills']).Name,
      Count8: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['$2 Bills']).Count,
      Val8: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['$2 Bills']).Amount,
      Coin9: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['$5 Bills']).Name,
      Count9: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['$5 Bills']).Count,
      Val9: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['$5 Bills']).Amount,
      Coin10: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['$10 Bills']).Name,
      Count10: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['$10 Bills']).Count,
      Val10: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['$10 Bills']).Amount,
      Coin11: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['$20 Bills']).Name,
      Count11: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['$20 Bills']).Count,
      Val11: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['$20 Bills']).Amount,
      Coin12: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['$50 Bills']).Name,
      Count12: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['$50 Bills']).Count,
      Val12: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['$50 Bills']).Amount,
      Coin13: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['$100 Bills']).Name,
      Count13: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['$100 Bills']).Count,
      Val13: this.listCoinsAndBills.find(l => l.Name == EDenominationsListOfValues['$100 Bills']).Amount,
    };
    const saveModel: IOpenCashModel = {
      Id: this.posOpenCashDetails ? this.posOpenCashDetails.Id : 0,
      UserName: this.userName,
      UserId: this.selectedUser,
      OpeningCashAmount: parseFloat(this.openingCashDrawerAmount.replace(/[$,]/g, '')),
      OpeningCashCoinsAndBills: (this.selectedTerminal && this.selectedTerminal != 'null' && this.checkCoinsBills && (parseFloat(this.openingCashDrawerAmount.replace(/[$,]/g, '')) > 0)) ? coinsAndBillsDetails : null,
      POSTerminalName: this.selectedTerminal
    }
    this.posOpeningCashDrawerService.saveOpeningCash(saveModel).pipe(takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        if (response.Success) {
          this.getOpeningCash(this.selectedTerminal);
          this.openCashSaved.emit(true);
          this.toastr.success($localize`:@@OpenCashDrawerAmt:Opening Cash for today is saved`, EToaster.TitleSuccess, this.sharedHTMLSettings.ToasterConfig);
        } else {
          this.loaderIcon = Promise.resolve(false);
          this.openCashSaved.emit(false);
          if (response?.Message == "ExistForSameTerminal") {
            this.toastr.warning(EToaster.MsgErrorSave + $localize`Open Cash already saved for a different terminal for the selected user`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
          }
          else if (response?.Message === 'InvalidTerminal') {
            this.toastr.warning('Please select your default terminal.', 'Warning', this.sharedHTMLSettings.ToasterConfig);
          }
          else {
            this.toastr.error(EToaster.MsgErrorSave + $localize`:@@OpenCashDrawerAmt:Opening Cash Amount`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
          }
        }
      },
      error: (error) => {
        this.openCashSaved.emit(false);
        this.loaderIcon = Promise.resolve(false);
        this.toastr.error(EToaster.MsgErrorSave + $localize`:@@OpenCashDrawerAmt:Opening Cash Amount`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
      },
    });
  }

  changeOpeningCashDrawer() {
    this.checkCoinsBills = false;
    this.clearGridCount();
  }

  openCashcheckBox() {
    this.openingCashDrawerAmount = '$0';
    this.clearGridCount();
  }
  clearGridCount() {
    this.gridTotal = 0;
    this.listCoinsAndBills.forEach(li => {
      li.Count = 0;
      li.Amount = 0;
    });
    this.gridCoinsBills.refreshColumns();
  }

  onBeforeOpen(args: any): void {
    if (!args || !args.target || !args.target.dataset || !args.target.dataset.content) {
      args.cancel = true;
    }
  }

  btnCancel() {
    this.selectedTerminal = 'null';
    this.router.navigate(['/dashboard']);
  }

  getReportUrl() {
    this.generalService.getReportUrl().subscribe((response: any) => {
      this.reportUrl = response;
    });
  }

  invokeReport(obj) {
    var openInNewTab = '_blank';
    this.loaderIcon = Promise.resolve(true);
    this.service.generateReport(obj).subscribe((response: IReportResponse) => {
      if (response.Success) {
        window.open(this.reportUrl + `report?id=` + response.ReportRequestId,
          openInNewTab, 'width=' + (screen.availWidth - 5) + ',height=' + (screen.availHeight - 5));
        this.loaderIcon = Promise.resolve(false);
      } else {
        console.log('Error on generating Operational Report');
        this.loaderIcon = Promise.resolve(false);
      }
    });
  }

  onReportView() {
    const obj = {
      ReportName: "OpeningCashReport",
      ReportParameters: {},
      MarketId: this.marketId
    };
    obj.ReportParameters["MarketId"] = this.marketId;
    obj.ReportParameters["OpeningDate"] = this.datePipe.transform(this.openingDateTime, 'MM/dd/yyyy');
    obj.ReportParameters["User"] = this.userName;
    obj.ReportParameters["Terminal"] = this.selectedTerminal;
    this.loaderIcon = Promise.resolve(false);
    this.invokeReport(obj);
  }
}
